import React from 'react'

const FooterSimple: React.FC = () => {
	return (
		<div className='w-full h-[6vh] min-h-[48px] flex items-center justify-between bg-gradient-to-r from-gray-50 to-slate-50 border-t border-gray-200/60 px-4 sm:px-6 md:px-8 relative overflow-hidden'>
			<div className='absolute inset-0 opacity-5'>
				<div
					className='absolute inset-0'
					style={{
						backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23dc2626' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
					}}
				/>
			</div>

			<p className='text-gray-600 text-xs sm:text-sm font-medium hover:text-gray-800 transition-colors duration-300 relative z-10 flex items-center space-x-2'>
				<span className='text-red-600 font-semibold'>©</span>
				<span>SportCenter Chinchiná Todos los derechos reservados</span>
			</p>

			<p className='text-gray-600 text-xs sm:text-sm font-medium hover:text-red-600 transition-colors duration-300 cursor-pointer relative z-10 flex items-center space-x-1'>
				<span>Términos y condiciones</span>
				<span className='text-red-600 opacity-0 hover:opacity-100 transition-opacity duration-300'>
					→
				</span>
			</p>
		</div>
	)
}

export default FooterSimple
